import type {ReactNode} from 'react';
import {Stack} from '../Stack';
import {Typography} from '../Typography';
import {WarningIcon} from '../icons';

export interface FieldLabelProps {
	required?: boolean;
	disabled?: boolean;
	children: ReactNode;
}

export interface FieldMessageProps {
	id: string;
	error: boolean;
	children: ReactNode;
}

export const FieldLabel = ({required = false, disabled = false, children}: FieldLabelProps) => (
	<Stack as='span' gap={0.5}>
		<Typography variant='small1' color={disabled ? 'textSecondary' : 'textPrimary'}>{children}</Typography>
		{required &&
			<Typography variant='small1' color={disabled ? 'textSecondary' : 'required'} aria-hidden>*</Typography>}
	</Stack>
);

export const FieldMessage = ({id, error, children}: FieldMessageProps) => (
	<Stack gap={1} alignItems='flexStart' className='mt-0.5'>
		{error && <WarningIcon aria-hidden color='critical' size='xs' className='mt-0.5 shrink-0'/>}
		{/* The id stays here rather than on the Stack, so aria-describedby reads the message and not the icon. */}
		<Typography id={id} variant='small3' color={error ? 'helperText' : 'textSecondary'}>{children}</Typography>
	</Stack>
);
